var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"openid-add"},[_c('OpenidForm',{attrs:{"operate":"add"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }